import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=6ff74f56&scoped=true"
import script from "./Province.vue?vue&type=script&lang=js"
export * from "./Province.vue?vue&type=script&lang=js"
import style0 from "./Province.vue?vue&type=style&index=0&id=6ff74f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff74f56",
  null
  
)

export default component.exports